const RoleTypes = {
  ACCESS: 'Access',
  PERMISSION: 'Permission'
};

export default RoleTypes;



// WEBPACK FOOTER //
// ./src/views/StaticData/Roles/Types.tsx